































import { Component, Vue } from 'vue-property-decorator';
import { ProductsModule } from '@/store/ProductsModule';
import ProductItem from '../components/Product.vue';

@Component({
  components: {
    ProductItem
  }
})
export default class Products extends Vue {
  public get loading() {
    return ProductsModule.loading;
  }

  public search: string = '';

  public get filteredProducts() {
    return this.search
      ? ProductsModule.items.filter((item) => item.title.toLowerCase().includes(this.search.toLowerCase()))
      : ProductsModule.items;
  }

  private created() {
    ProductsModule.fetchProducts();
  }
}
